import React, { useState } from "react";
import Header from "../Common/Header";
import Footer from "../Common/Footer";
import he from "he";

const faqsData = [
  {
    question: "How do I list my property on LandPanda?",
    category: "Listing",
    categoryID: 1,
    answer:
      'Click "Post Property" from the top navigation or sidebar menu. Fill in your property details including location, type, price, area, amenities, and upload photos. Your listing will go live after a quick verification. Posting is completely free!',
  },
  {
    question: "How can I boost my property listing for more visibility?",
    category: "Listing",
    categoryID: 1,
    answer:
      'Go to "My Listing" from the sidebar, then click "Boost" on any of your active listings. You can choose from different boost packages that increase your property&#8217s visibility in search results and featured sections. You can also use LandPanda Ads for targeted campaigns.',
  },
  {
    question: "Can I edit my property listing after posting?",
    category: "Listing",
    categoryID: 1,
    answer:
      'Yes, you can edit your listing anytime from "My Listing" section. Click the edit icon on your property card to update details, photos, price, or any other information. Major changes may require re-verification which usually takes 1-2 hours.',
  },
  {
    question: "How do I create an account on LandPanda?",
    category: "Account & Profile",
    categoryID: 2,
    answer:
      'Click "Login" from the header or sidebar. Enter your mobile number and verify it with the OTP sent to your phone. That is it — your account is created automatically. You can then update your profile with your name, email, and preferences.',
  },
  {
    question: "How do I update my profile information?",
    category: "Account & Profile",
    categoryID: 2,
    answer:
      "Go to your Profile page by clicking the user icon in the header. From there, you can update your name, email, profile photo, and notification preferences. Your phone number (used for login) cannot be changed directly — contact support for assistance.",
  },
  {
    question: "I'm not receiving OTP. What should I do?",
    category: "Account & Profile",
    categoryID: 2,
    answer:
      "Ensure your phone number is correct and has network coverage. Wait at least 60 seconds before requesting a new OTP. Check if your phone has any SMS blocking apps. If the issue persists, try using a different network or contact our support team.",
  },
  {
    question: "What payment methods are accepted?",
    category: "Payments & Plans",
    categoryID: 3,
    answer:
      "We accept UPI, credit/debit cards, net banking, and popular wallets like Paytm and PhonePe. All payments are processed securely through our payment gateway. You will receive a confirmation email and in-app notification after successful payment.",
  },
  {
    question: "Can I get a refund for my plan or credits?",
    category: "Payments & Plans",
    categoryID: 3,
    answer:
      "Credits and plans are non-refundable once purchased. However, if you face a technical issue where credits were deducted incorrectly, please raise a support ticket with details and we will investigate and restore credits if applicable within 3-5 business days.",
  },
  {
    question: "How do LandPanda Ads work?",
    category: "LandPanda Ads",
    categoryID: 4,
    answer:
      "LandPanda Ads let you create targeted campaigns for your property listings. Choose a property, set your budget and duration, and your listing gets premium placement in search results and featured sections. You can track impressions, clicks, and leads in real-time.",
  },
  {
    question: "What is the minimum budget for running an ad campaign?",
    category: "LandPanda Ads",
    categoryID: 4,
    answer:
      "The minimum daily budget for an ad campaign is ₹100. You can set a total campaign budget starting from ₹500. Campaign duration can range from 3 days to 90 days. Higher budgets result in more impressions and better placement.",
  },
];

export default function HelpCenter() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedCat, setSelectedCat] = useState(0);
  const [selectedCatName, setselectedCatName] = useState("All Topics");
    const [query, setquery] = useState("");

const filteredData = faqsData?.filter((item) => {
  const matchesCategory =
    selectedCat === 0 || item.categoryID === selectedCat;

  const matchesQuery =
    !query ||
    item.question?.toLowerCase().includes(query.toLowerCase()) ||
    item.answer?.toLowerCase().includes(query.toLowerCase());

  return matchesCategory && matchesQuery;
});
  return (
    <>
      <Header />
      <div className="helpcenter">
        {/* HERO */}
        <div className="hero">
          <div className="hero-content">
            <div className="icon">
              <i class="ri-customer-service-2-fill"></i>
            </div>
            <h1>How can we help you?</h1>
            <p>Search our knowledge base or browse categories below</p>
            <input value = {query} onChange={(e)=>setquery(e.target.value)} placeholder="Search for answers..." />
          </div>
        </div>

        {/* CATEGORY */}
        <div className="container">
          <h3 className="section-title">Browse by Category</h3>

          <div className="categories">
            <div
              onClick={() => {
                setSelectedCat(0);
                setselectedCatName("All Topics");
              }}
              className={selectedCat === 0 ? "card active" : "card"}
            >
              <div className="icoos">
                <i class="ri-apps-line text-lg sm:text-xl text-emerald-600"></i>
              </div>
              <h4>All Topics</h4>
              <span>10 articles</span>
            </div>

            <div
              onClick={() => {
                setSelectedCat(2);
                setselectedCatName("Account & Profile");
              }}
              className={selectedCat === 2 ? "card active" : "card"}
            >
              <div className="icoos">
                <i class="ri-user-settings-line text-lg sm:text-xl text-gray-500"></i>
              </div>
              <h4>Account & Profile</h4>
              <span>3 articles</span>
            </div>

            <div
              onClick={() => {
                setSelectedCat(3);
                setselectedCatName("Payments & Plans");
              }}
              className={selectedCat === 3 ? "card active" : "card"}
            >
              <div className="icoos">
                <i class="ri-bank-card-line text-lg sm:text-xl text-gray-500"></i>
              </div>
              <h4>Payments & Plans</h4>
              <span>2 articles</span>
            </div>

            <div
              onClick={() => {
                setSelectedCat(4);
                setselectedCatName("LandPanda Ads");
              }}
              className={selectedCat === 4 ? "card active" : "card"}
            >
              <div className="icoos">
                <i class="ri-megaphone-line text-lg sm:text-xl text-gray-500"></i>
              </div>
              <h4>LandPanda Ads</h4>
              <span>2 articles</span>
            </div>

            <div
              onClick={() => {
                setSelectedCat(1);
                setselectedCatName("Listing");
              }}
              className={selectedCat === 1 ? "card active" : "card"}
            >
              <div className="icoos">
                <i class="ri-price-tag-3-line text-lg sm:text-xl text-gray-500"></i>
              </div>
              <h4>Listing</h4>
              <span>3 articles</span>
            </div>
          </div>

          {/* FAQ */}
          <h3 className="section-title mt">{query == "" ? `FAQs — ${selectedCatName}` : `Results For - ${query}` } </h3>
          <p className="sub-text">{filteredData?.length} questions found</p>

          <div className="faq">
            {filteredData?.map((item, index) => (
              <div
                key={index}
                className={`faq-item ${activeIndex === index ? "open" : ""}`}
                onClick={() =>
                  setActiveIndex(activeIndex === index ? null : index)
                }
              >
                <div className="faq-header">
                  <span className="plus">
                    {activeIndex === index ? "-" : "+"}
                  </span>
                  <div>
                    <p>{item.question}</p>
                    <span className="tag">{item.category}</span>
                  </div>
                </div>

                {activeIndex === index && item.answer && (
                  <div className="faq-body">{item.answer}</div>
                )}
              </div>
            ))}
          </div>

          {/* HELP */}
          <div className="help-box">
            <h3>Still need help?</h3>
            <p>
              Can't find what you're looking for? Reach out to our support team.
            </p>

            <div className="help-cards">
              <div className="help-card green">
                <div className="icoos green">
                  <i
                    class="ri-mail-send-line text-lg sm:text-xl text-emerald-600"
                    style={{ color: "#005519" }}
                  ></i>
                </div>
                <h4>Email Us</h4>
                <p>Get a response within 24 hours</p>
                <button>support@landpanda.com</button>
              </div>

              <div className="help-card blue">
                <div className="icoos blue">
                  <i
                    class="ri-phone-line text-lg sm:text-xl text-sky-600"
                    style={{ color: "#1100a8" }}
                  ></i>
                </div>
                <h4>Call Us</h4>
                <p>Mon–Sat, 9 AM – 7 PM IST</p>
                <button>+91 8796011518</button>
              </div>

              {/* <div className="help-card yellow">
                <div className="icoos blue">
                  <i
                    class="ri-ticket-2-line text-lg sm:text-xl text-amber-600"
                    style={{ color: "#d99a07" }}
                  ></i>
                </div>
                <h4>Raise a Ticket</h4>
                <p>Track your issue with a ticket ID</p>
                <button>Create Ticket</button>
              </div> */}
            </div>
          </div>

          {/* TIPS */}
          <div className="tips">
            <h3>Quick Tips</h3>

            <div className="tips-grid">
              <div className="tip green">
                <div>
                  {" "}
                  <div className="icoos blue">
                    <i class="ri-shield-check-line text-base sm:text-lg text-emerald-600"></i>
                  </div>
                </div>
                <div>
                  <h4>Verify Before You Pay</h4>
                  <p>Always verify documents before payment.</p>
                </div>
              </div>

              <div className="tip blue">
                <div>
                  {" "}
                  <div className="icoos blue">
                    <i
                      class="ri-camera-line text-base sm:text-lg text-sky-600"
                      style={{ color: "#1100a8" }}
                    ></i>
                  </div>
                </div>
                <div>
                  <h4>Upload Clear Photos</h4>
                  <p>Use high-quality images for better reach.</p>
                </div>
              </div>

              <div className="tip yellow">
                <div>
                  {" "}
                  <div className="icoos blue">
                    <i
                      class="ri-price-tag-3-line text-base sm:text-lg text-amber-600"
                      style={{ color: "#d99a07" }}
                    ></i>
                  </div>
                </div>
                <div>
                  <h4>Set Realistic Pricing</h4>
                  <p>Research nearby listings for pricing.</p>
                </div>
              </div>

              <div className="tip red">
                <div>
                  {" "}
                  <div className="icoos blue">
                    <i class="ri-spam-2-line text-base sm:text-lg text-rose-600"></i>
                  </div>
                </div>
                <div>
                  <h4>Report Suspicious Listings</h4>
                  <p>Report fraud listings immediately.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
